import { render, staticRenderFns } from "./RegistrarAutorizacao.vue?vue&type=template&id=723dc59c&"
import script from "./RegistrarAutorizacao.vue?vue&type=script&lang=js&"
export * from "./RegistrarAutorizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports